import(/* webpackMode: "eager" */ "/app/frontend/src/app/(auth)/register/driver/page.tsx");
